import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { TFunction } from 'i18next';
import type { JSX } from 'react';
import React from 'react';

import type { SegmentExport } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';
import * as styles from './optionsColumn.css';

/**
 * Renders an inert 3-dot icon in the Options column. Intentionally
 * non-interactive — no `onClick`, no hover, no cursor:pointer.
 */
function OptionsCell(): JSX.Element {
  return (
    <span aria-hidden={true} className={styles.kebab} data-name={'options-kebab'}>
      <FontAwesomeIcon icon={faEllipsisV} />
    </span>
  );
}

const optionsColumn = (t: TFunction): IColumn<SegmentExport> => ({
  id: 'options',
  checkboxLabel: t('Options'),
  Header: TableColumnHeader({ title: t('Options') }),
  width: 80,
  sortable: false,
  className: tableStyles.cellCenter,
  Cell(): JSX.Element {
    return <OptionsCell />;
  },
});

export default optionsColumn;
